import { UserComponent } from '@craftjs/core';
import { FormFieldProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormTextInputProps = Omit<
  FormFieldProps & {
    type?: 'text-area' | 'number' | 'text';
    placeholder?: string;
    units?: string;
    decimal?: number;
  },
  'defaultValue'
>;

export const formTextInputDefaultProps: FormTextInputProps = {
  dataKey: createId(),
  title: 'Form text input',
  placeholder: 'Enter text here',
};

export const formMultipleTextInputDefaultProps: FormTextInputProps = {
  dataKey: createId(),
  title: 'Form multiple text input',
  placeholder: 'Enter text here',
};

export type FormTextInputComponent = UserComponent<FormTextInputProps>;
